// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"85b81337","6140":"85b81337","7071":"43b470d1"}[chunkId] + ".chunk.css";
};